import { useTranslation } from 'react-i18next'
import { telHref } from '@/lib/format'
import type { Stay } from '@/services/reserva'
import { BackLink } from '../Pagos/shared'
import './Accesos.css'

/** Rutas de la pestaña Accesos (inventario D16; `/accesos/instrucciones` añadida en el bloque 4). */
export const ACCESS_ROUTES = {
  home: '/accesos',
  code: '/accesos/codigo',
  instructions: '/accesos/instrucciones',
  directions: '/accesos/como-llegar',
  climate: '/accesos/clima',
} as const

/** Enlace "← Accesos" de las pantallas de detalle (AccesosDetalle.dc.html). */
export function AccessBack() {
  const { t } = useTranslation()
  return <BackLink to={ACCESS_ROUTES.home} label={t('v2.accesos.volver')} />
}

/** "Emergencias: +34 600 123 456", siempre visible y disponible sin conexión (DESIGN.md §7). */
export function EmergencyLine({ phone }: { phone: string | null }) {
  const { t } = useTranslation()
  if (!phone) return null
  return (
    <p className="accesos__emergency">
      {t('v2.ds.contact.emergencias')}{' '}
      <a href={telHref(phone)} className="tnum">
        {phone}
      </a>
    </p>
  )
}

export const emergencyPhone = (stay: Stay) => stay.contact.emergencyPhone ?? stay.contact.supportPhone

/** Nombre de la unidad o, si no hay, de la propiedad. */
export const placeName = (stay: Stay) => stay.unit.name || stay.property.name
